import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";
import { colors } from "../../../../../utils/colors";
import { carouselSectionPadding } from "../../../CarouselSection/styled";

export const Outer = styled.div`
    ${carouselSectionPadding}
`;

export const Inner = styled.div`
    margin-top: 25px;
    background-color: ${colors.brandXXXLight};
    padding: 16px 32px;
    border-radius: 16px;

    display: grid;
    grid-template-columns: 1fr;
    gap: 0 32px;

    ${breakpoints.medium} {
        padding: 32px 50px;
        grid-template-columns: 1fr 1fr;
    }

    ${breakpoints.large} {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }
`;

export const Title = styled.h3`
    font-size: 25px;

    ${breakpoints.large} {
        font-size: 32px;
    }
`;
